// extracted by mini-css-extract-plugin
module.exports = {"Container":"BackgroundVideo_Container__3VXQS","Video":"BackgroundVideo_Video__37ugc","Content":"BackgroundVideo_Content__3dbOL","SubContent":"BackgroundVideo_SubContent__1H5cr"};